import React, { useRef } from "react";
import Image, { StaticImageData } from "next/image";

import useScrollIn from "@kikoff/hooks/src/useScrollIn";
import { combineClasses } from "@kikoff/utils/src/string";

import styles from "./captioned_image.module.scss";

type CaptionedImageProps =
  | {
      title: React.ReactNode;
      body: React.ReactNode;
      src: StaticImageData;
      imgComponent?: null;
      imgSide: "right" | "left";
      className?: string;
    }
  | {
      title: React.ReactNode;
      body: React.ReactNode;
      src?: null;
      imgComponent: React.ReactNode;
      imgSide: "right" | "left";
      className?: string;
    };

const CaptionedImage: React.FC<CaptionedImageProps> = ({
  title,
  body,
  src,
  imgComponent,
  imgSide,
  className,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const allowAnimate = false;
  const show = !allowAnimate || useScrollIn(ref);

  return (
    <div
      className={combineClasses(
        styles["captioned-image"],
        styles[imgSide],
        show && styles.show,
        className
      )}
      ref={ref}
    >
      <div className={styles["image-container"]}>
        {imgComponent || (
          <Image
            src={src}
            alt=""
            className={styles.image}
            layout="responsive"
          />
        )}
      </div>
      <div className={styles.spacer} />
      <div className={styles.caption}>
        <header>{title}</header>
        <div className={styles.body}>{body}</div>
      </div>
    </div>
  );
};

export default CaptionedImage;
